import React from "react";
import { AuthenticationManager, ResourceID } from "../../../common/AuthenticationManager";
import { GenericMessages } from "../../../common/Constants";
import { StringHelper } from "../../../common/Helpers";
import RestClient from "../../../common/RestClient";
import { BreadCrumb } from "../../common/BreadCrumb";
import { ConfirmDialog } from "../../common/ConfirmDialog";
import { CancelPreviewButton } from "../common/CancelPreviewButton";
import { CardMode } from "../common/CardMode";
import { LocationDetailCard } from "./cards/LocationDetailCard";
import { LocationPreview } from "./preview/LocationPreview";
import {
  NavigationItem,
  NavigationSettings,
} from "../../common/NavigationSettings";
import { toast } from "react-toastify";
import ButtonActionDetailGroup from "../../common/ButtonActionDetailGroup";

const DetailPageName = "View Scheduled Location";
const EditPageName = "Edit Scheduled Location";

export class ScheduledLocationDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardMode: CardMode.ScheduleView,
      generalInfo: null,
      generalInfoValidations: [],
      scheduledLocationId: null,
      showCancelDialog: false,
      showConfirmDialog: false,
      showPreview: false,
      showDeleteModal: false,
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    const scheduledLocationId = StringHelper.toNumber(id, 0);
    if (isNaN(id) || scheduledLocationId <= 0) {
      this.redirectToListingPage();
      return;
    }
    this.setState({ scheduledLocationId }, this.refreshData);
  }

  isValidated() {
    const { generalInfoValidations } = this.state;
    return generalInfoValidations.every((val) => val.isValid);
  }

  loadScheduledLocation(id) {
    RestClient.sendGetRequest(
      `/api/v1/scheduled_locations/${id}`,
      (response) => {
        this.setState({ scheduledLocation: response });
      },
      (errorResponse) => {
        toast.error(errorResponse.message);
      }
    );
  }

  onEditScheduledLocationClick = () => {
    this.setState({ cardMode: CardMode.ScheduleUpdate });
  };

  onGeneralInfoModelChange = (model) => {
    const displayStartTime = StringHelper.toDateTimeString(
      model.displayStartTimeStr
    );
    const displayEndTime = StringHelper.toDateTimeString(
      model.displayEndTimeStr
    );
    const displayWeight = StringHelper.toNumber(model.displayWeight, 0);
    const planToPublish = StringHelper.toDateTimeString(model.planToPublishStr);
    const newModel = Object.assign(model, {
      displayStartTime,
      displayEndTime,
      planToPublish,
      displayWeight,
    });
    this.setState({ generalInfo: newModel });
  };

  onGeneralInfoValidationsChange = (validations) => {
    this.setState({ generalInfoValidations: validations });
  };

  onHideCancelDialog = () => {
    this.setState({ showCancelDialog: false });
  };

  onHideConfirmDialog = () => {
    this.setState({ showConfirmDialog: false });
  };

  onHidePreview = () => {
    this.setState({ showPreview: false });
  };

  onProceedCancelDialog = () => {
    this.setState({
      cardMode: CardMode.ScheduleView,
      scheduledLocation: Object.assign({}, this.state.scheduledLocation),
      showCancelDialog: false,
    });
  };

  onProceedConfirmDialog = () => {
    if (!this.isValidated()) {
      this.setState({ isSubmit: true, showConfirmDialog: false });
      return;
    }
    const { generalInfo, scheduledLocationId } = this.state;
    const request = Object.assign(
      {},
      generalInfo
    );
    RestClient.sendPutRequest(
      `/api/v1/scheduled_locations/${scheduledLocationId}`,
      request,
      (response) => {
        toast.success(GenericMessages.SaveChangesSuccessfulMessage);
        this.setState({
          cardMode: CardMode.ScheduleView,
          isSubmit: false,
          scheduledLocation: response,
          showConfirmDialog: false,
        });
      },
      (errorResponse) => {
        toast.error(errorResponse.message);
        this.setState({
          showConfirmDialog: false,
        });
      }
    );
  };

  onShowCancelDialog = () => {
    this.setState({ showCancelDialog: true });
  };

  onShowConfirmDialog = () => {
    if (!this.isValidated()) {
      this.setState({ isSubmit: true });
      return;
    }
    this.setState({ showConfirmDialog: true });
  };

  onShowPreview = () => {
    this.setState({ showPreview: true });
  };

  redirectToListingPage(additionalParameter) {
    this.props.history.push(
      `/locations/schedules/${additionalParameter ?? ""}`
    );
  }

  refreshData() {
    const { scheduledLocationId } = this.state;
    this.loadScheduledLocation(scheduledLocationId);
  }

  getNavigationSettings = () => {
    const { cardMode } = this.state;
    return new NavigationSettings({
      rootModule: new NavigationItem({
        identifier: "website_managements",
        name: "Website Management",
      }),
      parentModule: new NavigationItem({
        identifier: "locations",
        name: "Locations",
      }),
      activeModule: new NavigationItem({
        identifier: "schedule-location-details",
        name: CardMode.isViewMode(cardMode) ? DetailPageName : EditPageName,
      }),
    });
  };

  onDelete = () => {
    this.setState({ showDeleteModal: true });
  };

  onCancel = () => {
    this.setState({ showDeleteModal: false });
  };

  onProceedDelete = () => {
    const { scheduledLocationId } = this.state;
    RestClient.sendDeleteRequest(
      `/api/v1/scheduled_locations/${scheduledLocationId}`,
      () => {
        toast.success("The scheduled location has been deleted successful.");
        this.redirectToListingPage();
      }, (errorResponse) => {
        toast.error(errorResponse.message);
      }
    );
    this.setState({ showDeleteModal: false });
  }

  render() {
    const {
      cardMode,
      isSubmit,
      generalInfo,
      scheduledLocation,
      showCancelDialog,
      showConfirmDialog,
      showPreview,
      showDeleteModal,
    } = this.state;
    if (showPreview) {
      const previewModel = Object.assign(
        {},
        generalInfo
      );
      return (
        <>
          <LocationPreview location={previewModel} />
          <CancelPreviewButton onClick={this.onHidePreview} />
        </>
      );
    }
    return (
      <div className="main-content">
        <BreadCrumb navigationSettings={this.getNavigationSettings()} />
        <div className="section__content section__content--p30">
          <div className="container-fluid">
            {CardMode.isViewMode(cardMode) && (
              <div className="row mb-3">
                <div className="col">
                  <div className="d-flex flex-row-reverse">
                    {AuthenticationManager.isAuthorized(
                      ResourceID.LocationScheduledEditButtonPage
                    ) && (
                        <>
                          <button
                            className="btn btn-primary ml-2 mb-2"
                            value="Edit"
                            disabled={scheduledLocation ? undefined : "disabled"}
                            onClick={this.onEditScheduledLocationClick}
                          >
                            <i className="fas fa-edit"></i> Edit
                          </button>
                          <button
                            className="btn btn-danger ml-2 mb-2"
                            value="Delete Schedule"
                            disabled={scheduledLocation ? undefined : "disabled"}
                            onClick={this.onDelete}
                          > Delete Schedule
                          </button>
                        </>
                      )}
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-12">
                <LocationDetailCard
                  cardMode={cardMode}
                  defaultValue={scheduledLocation}
                  isSubmit={isSubmit}
                  model={generalInfo}
                  onModelChange={this.onGeneralInfoModelChange}
                  onValidationsChange={this.onGeneralInfoValidationsChange}
                />
              </div>
            </div>
            {CardMode.isEditMode(cardMode) && (
              <ButtonActionDetailGroup>
                <ButtonActionDetailGroup.Item
                  className="btn btn-outline-secondary"
                  onClick={this.onShowPreview}
                >
                  Preview
                </ButtonActionDetailGroup.Item>
                <ButtonActionDetailGroup.Item
                  className="btn btn-success"
                  onClick={this.onShowConfirmDialog}
                >
                  Save Changes
                </ButtonActionDetailGroup.Item>
                <ButtonActionDetailGroup.Item
                  className="btn btn-danger"
                  onClick={this.onShowCancelDialog}
                >
                  Cancel
                </ButtonActionDetailGroup.Item>
              </ButtonActionDetailGroup>
            )}
          </div>
        </div>
        <ConfirmDialog
          visible={showCancelDialog && scheduledLocation}
          onCancel={this.onHideCancelDialog}
          onProceed={this.onProceedCancelDialog}
          message={GenericMessages.CancelChangesDialogMessage}
          title={GenericMessages.CancelChangesDialogTitle}
        />
        <ConfirmDialog
          visible={showConfirmDialog && scheduledLocation}
          onCancel={this.onHideConfirmDialog}
          onProceed={this.onProceedConfirmDialog}
          message={GenericMessages.SaveChangesDialogMessage}
          title={GenericMessages.SaveChangesDialogTitle}
        />
        <ConfirmDialog
          visible={showDeleteModal}
          message={"Are you sure you want to delete this scheduled location?"}
          onProceed={this.onProceedDelete}
          onCancel={this.onCancel}
        />
      </div>
    );
  }
}
